export const STORE_NAME = 'core/blocks';
//# sourceMappingURL=constants.js.map